import { forOwn } from 'lodash-es'

const settings = {
    AUTH0_CLIENT_ID: {
        required: true,
        value: process.env.REACT_APP_AUTH0_CLIENT_ID,
    },
    AUTH0_DOMAIN: {
        required: true,
        value: process.env.REACT_APP_AUTH0_DOMAIN,
    },
    BASE_URL: {
        required: true,
        value: process.env.REACT_APP_BASE_URL,
    },
    CALENDAR_URL: {
        required: false,
        value:
            process.env.REACT_APP_CALENDAR_URL ||
            'https://geekbattle.online/',
    },
    CLOUDINARY_CLOUD_NAME: {
        required: true,
        value: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME,
    },
    FACEBOOK_PIXEL_ID: {
        required: false,
        value: process.env.REACT_APP_FACEBOOK_PIXEL_ID,
    },
    GOOGLE_ANALYTICS_ID: {
        required: false,
        value: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
    },
    ID_TOKEN_NAMESPACE: {
        required: true,
        value:
            process.env.REACT_APP_ID_TOKEN_NAMESPACE ||
            'https://geekbattle.online/',
    },
    IS_DEBUG: {
        default: process.env.NODE_ENV === 'development',
        required: true,
        value: process.env.IS_DEBUG,
    },
    LOGO_DARK_URL: {
        required: true,
        value:
            process.env.REACT_APP_LOGO_DARK_URL ||
            //'https://res.cloudinary.com/hackjunction/image/upload/c_scale,w_500/v1581419636/Junction%20Logos/wordmark_black.png',
            //'https://res.cloudinary.com/hackjunction/image/upload/v1606900986/Junction%20Logos/app.svg',
            //'https://res.cloudinary.com/hackatonapp/image/upload/v1617345599/samples/hackerpack/Logo_qxawoh.svg',
            'https://res.cloudinary.com/hackatonapp/image/upload/v1617345599/GeekBattle/Logo/Logo_qxawoh.svg',
    },
    LOGO_LIGHT_URL: {
        required: true,
        value:
            process.env.REACT_APP_LOGO_LIGHT_URL ||
            //'https://res.cloudinary.com/hackjunction/image/upload/c_scale,w_500/v1581419635/Junction%20Logos/wordmark_white.png',
            'https://res.cloudinary.com/hackatonapp/image/upload/v1617345599/GeekBattle/Logo/Logo_qxawoh.svg',
    },
    EMBLEM_DARK_URL: {
        required: true,
        value:
            'https://res.cloudinary.com/hackjunction/image/upload/v1581419640/Junction%20Logos/emblem_black.png',
    },
    LOGROCKET_ID: {
        required: false,
        value: process.env.REACT_APP_LOGROCKET_ID,
    },
    PLATFORM_OWNER_NAME: {
        required: true,
        value: process.env.REACT_APP_PLATFORM_OWNER_NAME || 'GeekBattle',
    },
    PLATFORM_OWNER_NAME_CAPS: {
        required: true,
        value: process.env.REACT_APP_PLATFORM_OWNER_NAME || 'GeekBattle',
    },
    PLATFORM_OWNER_WEBSITE: {
        required: true,
        value:
            process.env.REACT_APP_PLATFORM_OWNER_WEBSITE ||
            'https://ferma.digital',
    },
    PRIVACY_URL: {
        required: false,
        value:
            process.env.REACT_APP_PRIVACY_URL ||
            '/privacy',
    },
    SEO_IMAGE_URL: {
        required: false,
        value:
            process.env.REACT_APP_SEO_IMAGE_URL ||
            'https://res.cloudinary.com/hackatonapp/image/upload/v1619794913/GeekBattle/Logo/Seo_logo_ostrjq.jpg',
    },
    SEO_PAGE_DESCRIPTION: {
        required: true,
        value:
            process.env.REACT_APP_SEO_PAGE_DESCRIPTION ||
            'GeekBattle - take part in hackatons!',
    },
    SEO_PAGE_TITLE: {
        required: true,
        value:
            process.env.REACT_APP_SEO_PAGE_TITLE ||
            'GeekBattle',
    },
    SEO_TWITTER_HANDLE: {
        required: false,
        value: process.env.REACT_APP_SEO_TWITTER_HANDLE || '',
    },
    TERMS_URL: {
        required: false,
        value:
            process.env.REACT_APP_TERMS_URL || '/terms',
    },
    SEO_PAGE_LOGIN_DESCRIPTION: {
        required: true,
        value: 'Login to see something',
    },
}
const buildConfig = () => {
    const config = {}
    forOwn(settings, (obj, key) => {
        if (!obj.value) {
            if (typeof obj.default !== 'undefined') {
                config[key] = obj.default
            } else {
                if (obj.required) {
                    throw new Error(
                        `Invalid configuration: ${key} must be provided a value from .env, or a default value. See config.js`,
                    )
                }
            }
        } else {
            config[key] = obj.value
        }
    })

    return config
}

const config = buildConfig()

export default config
